import {
  AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnDestroy, Output, ViewChild
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MenuItem } from 'primeng/api';

import { ContextSubmenuComponent } from './context-submenu.component';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss']
})
export class ContextMenuComponent implements AfterViewInit, OnDestroy {

  items: MenuItem[] = [];

  @Output() closed = new EventEmitter<void>();
  @ViewChild(MatMenuTrigger) private trigger!: MatMenuTrigger;
  @ViewChild('root') private root!: ContextSubmenuComponent;

  x = 0;
  y = 0;

  private restoreFocusTarget: HTMLElement | null = null;

  private readonly pointerDownHandler = (event: PointerEvent): void => {
    if (!this.trigger.menuOpen) return;
    if (event.button === 2) return;
    if (this.isInsideMenu(event)) return;
    this.close();
  };

  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    document.addEventListener('pointerdown', this.pointerDownHandler, true);
  }

  ngOnDestroy(): void {
    document.removeEventListener('pointerdown', this.pointerDownHandler, true);
  }

  open(event: MouseEvent, items: MenuItem[]): void {
    event.preventDefault();
    this.items = items;
    this.x = event.clientX;
    this.y = event.clientY;
    const focusTarget = (event.target as HTMLElement | null)?.closest('tr') as HTMLElement ?? null;
    if (this.trigger.menuOpen) {
      this.trigger.closeMenu();
      setTimeout(() => this.doOpen(focusTarget));
      return;
    }
    this.doOpen(focusTarget);
  }

  onMenuClosed(): void {
    this.closed.emit();
    const target = this.restoreFocusTarget;
    this.restoreFocusTarget = null;
    target?.focus({ preventScroll: true });
  }

  private doOpen(focusTarget: HTMLElement | null): void {
    this.restoreFocusTarget = focusTarget;
    this.cdr.detectChanges();
    this.trigger.openMenu();
    this.detachClosingPanels();
    this.trigger.updatePosition();
    this.cdr.detectChanges();
  }

  private detachClosingPanels(): void {
    const panel = document.getElementById(this.root.menu.panelId);
    panel?.parentElement?.querySelectorAll<HTMLElement>('.mat-menu-panel')
      .forEach(other => {
        if (other !== panel) other.style.position = 'absolute';
      });
  }

  close(): void {
    if (this.trigger.menuOpen) {
      this.trigger.closeMenu();
    }
  }

  // tylko panele samego menu (root + podmenu), nie cały cdk-overlay-container — menu bywa
  // otwierane z wnętrza innego overlaya (np. panel "Widoczność kolumn") i wtedy kliknięcia
  // w tamten panel są w tym samym kontenerze, więc menu nigdy by się nie zamykało
  private isInsideMenu(event: PointerEvent): boolean {
    return event.composedPath().some(node =>
      node instanceof Element && node.classList.contains('pt-context-menu'));
  }
}
